export default {
    path: '/*',
    redirect: '/',
};
